import Vue from 'vue';
import VueRouter from 'vue-router';
import loginRoutes from './authRoute'
import indexRoute from './indexRoute'
import smsRoute from './smsRoute'
import settingsRoute from './settingsRoute'

Vue.use(VueRouter);

const routes = [
    ...indexRoute,
    ...loginRoutes,
    ...smsRoute,
    ...settingsRoute
]

// const routes = [
//   {
//     path: '/',
//     name: 'home',
//     component: Home,
//     meta: {
//       layout: 'dashboard'
//     }
//   },
//   {
//     path: '/about',
//     name: 'about',
//     // route level code-splitting
//     // this generates a separate chunk (about.[hash].js) for this route
//     // which is lazy-loaded when the route is visited.
//     component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
//   }
// ];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    linkActiveClass: 'active',
    routes
});

export default router;
